// Утилиты для Form3

import { parseDecimal } from '../../../utils/decimalUtils';
import { numberFormatOk } from '../../../utils/cardValidation';

// Функции валидации для дробных чисел подлеска
export const validateSrednayaVysota = (value) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num >= 1000) return false; // Максимум 999.9
  return true;
};

export const formatSrednayaVysota = (value) => {
  if (!value || value === '') return '';
  const num = parseDecimal(value);
  if (isNaN(num)) return '';
  
  // Ограничиваем до 999.9
  if (num >= 1000) {
    return '999.9';
  }
  
  return num.toFixed(1);
};

export const validateUklon = (value) => {
  if (!value) return false;
  const num = parseInt(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num > 99) return false;
  return true;
};

export const formatUklon = (value) => {
  if (!value || value === '') return '';
  const num = parseInt(value);
  if (isNaN(num)) return '';
  return Math.min(Math.max(num, 0), 99).toString();
};

// Функции валидации для подростка
export const validateSredniyVozrast = (value) => {
  if (!value) return false;
  const num = parseInt(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num > 999) return false;
  return true;
};

export const formatSredniyVozrast = (value) => {
  if (!value || value === '') return '';
  const num = parseInt(value);
  if (isNaN(num)) return '';
  return Math.min(Math.max(num, 0), 999).toString();
};

export const validatePodrostSrednayaVysota = (value) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num >= 1000) return false; // Максимум 999.9
  return true;
};

export const formatPodrostSrednayaVysota = (value) => {
  if (!value || value === '') return '';
  const num = parseDecimal(value);
  if (isNaN(num)) return '';
  
  // Ограничиваем до 999.9
  if (num >= 1000) {
    return '999.9';
  }
  
  return num.toFixed(1);
};

export const validatePodrostGustota = (value) => {
  return String(value ?? '').trim() !== '' && numberFormatOk(value, 3, 2);
};

export const formatPodrostGustota = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') return '';
  // Старые ошибочные значения сохраняем для исправления, не подменяем пределом.
  return validatePodrostGustota(value) ? parseDecimal(value).toFixed(2) : String(value);
};

